import NotFound from "./View";

const screen = {
  path: "*",
  exact: false,
  element: <NotFound />,
};

export default screen;
